module.exports = __webpack_public_path__ + "static/img/pump_auto.21120c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base_layer_img/pump_auto.png
// module id = CdPs
// module chunks = 1